export const inViewport = element => {
  if (!element) return false

  // get window height
  const windowHeight = window.innerHeight
  // get number of pixels that the document is scrolled
  const scrollY = window.scrollY || window.pageYOffset

  // get current scroll position (distance from the top of the page to the bottom of the current viewport)
  const scrollPosition = scrollY + windowHeight
  // get element position (distance from the top of the page to the bottom of the element)
  const elementBottomPosition =
    element.getBoundingClientRect().top +
    scrollY +
    element.getBoundingClientRect().height

  const elementTopPosition = element.getBoundingClientRect().top + scrollY

  // is element in view?
  const scrolledIntoView = scrollPosition > elementBottomPosition
  const scrolledOutOfView = elementTopPosition < scrollY

  return scrolledIntoView && !scrolledOutOfView
}
